










import { Vue, Component } from 'vue-property-decorator';
import ConsultarFolio from '@/pantallas/ConsultarFolio/ConsultarFolio.vue';

@Component({
  components: { ConsultarFolio },
})
export default class ConsultarFolioPantalla extends Vue {}
